// extracted by mini-css-extract-plugin
module.exports = {"Flag":"Flag_Flag__7gKSK","Flag--is-rounded":"Flag_Flag--is-rounded__18VgC"};